var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: {
        timeout: _vm.time,
        rounded: "pill",
        light: _vm.error,
        right: _vm.right,
        app: _vm.app,
        "min-width": _vm.maxWidth ? "90%" : null,
        "max-width": _vm.maxWidth,
      },
      on: { input: _vm.clear },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function ({ attrs }) {
            return [
              _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { color: _vm.error ? "error" : "primary", text: "" },
                    on: {
                      click: function ($event) {
                        _vm.snack = false
                      },
                    },
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [_vm._v("\n            Close\n        ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.snack,
        callback: function ($$v) {
          _vm.snack = $$v
        },
        expression: "snack",
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.text) + "\n\n    ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }